'use client';

import { useQuery, useMutation } from '@apollo/client/react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import { myDiscordLinkQuery, updateDiscordNotificationPreferencesMutation } from '../../apollo/discord';

const DiscordNotificationsSection = () => {
  const { data, loading } = useQuery(myDiscordLinkQuery, { ssr: false });
  const [updatePreferences] = useMutation(updateDiscordNotificationPreferencesMutation);

  const discordLink = data?.me?.discordLink;

  if (loading || !discordLink?.isLinked) {
    return null;
  }

  const handleToggle = (field: 'dmEventReminders' | 'dmEventUpdates') => async () => {
    const newValue = !discordLink[field];
    await updatePreferences({
      variables: { [field]: newValue },
      optimisticResponse: {
        updateDiscordNotificationPreferences: {
          __typename: 'DiscordUserLink',
          id: discordLink.id,
          dmEventReminders: field === 'dmEventReminders' ? newValue : discordLink.dmEventReminders,
          dmEventUpdates: field === 'dmEventUpdates' ? newValue : discordLink.dmEventUpdates,
          dmEventComments: discordLink.dmEventComments,
        },
      },
    });
  };

  const handleRadioChange = (field: 'dmEventComments', value: string) => async () => {
    await updatePreferences({
      variables: { [field]: value },
      optimisticResponse: {
        updateDiscordNotificationPreferences: {
          __typename: 'DiscordUserLink',
          id: discordLink.id,
          dmEventReminders: discordLink.dmEventReminders,
          dmEventUpdates: discordLink.dmEventUpdates,
          dmEventComments: value,
        },
      },
    });
  };

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h3">Direct messages</Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={discordLink.dmEventReminders}
                onChange={handleToggle('dmEventReminders')}
              />
            }
            label="Event reminders"
          />
          <FormControlLabel
            control={
              <Switch
                checked={discordLink.dmEventUpdates}
                onChange={handleToggle('dmEventUpdates')}
              />
            }
            label="Event updates"
          />
        </FormGroup>
        <FormControl sx={{ mt: 2 }}>
          <FormLabel>Event comments</FormLabel>
          <RadioGroup
            value={discordLink.dmEventComments}
            onChange={(e) => handleRadioChange('dmEventComments', e.target.value)()}
          >
            <FormControlLabel value="NONE" control={<Radio />} label="Off" />
            <FormControlLabel value="HOST_ONLY" control={<Radio />} label="Only from hosts" />
            <FormControlLabel value="ALL_RSVPS" control={<Radio />} label="All comments" />
          </RadioGroup>
        </FormControl>
    </Paper>
  );
};

export default DiscordNotificationsSection;
